import routesData from '@/src/routesData.local.json';

export type Category = {
  slug: string;
  id: number;
};

const slugs = Object.keys(routesData);
const categories = [] as Category[];
slugs.map((slug) => {
  const page = routesData[slug as keyof typeof routesData];
  if (page.type !== 'category') {
    return;
  }
  categories.push({
    id: page.id,
    slug,
  });
});

export default function getMainCategories(): Category[] {
  return categories;
}

export function getCategoriesData(slugOrId = false as false | number | string) {
  const slugs = Object.keys(routesData);
  const categories = [] as any[];
  let category: any;
  slugs.map((slug) => {
    const page = routesData[slug as keyof typeof routesData];
    if (page.type !== 'category') {
      return;
    }
    if (slug === slugOrId || page.id === slugOrId) {
      category = { ...page, slug };
    }
    categories.push({ ...page, slug });
  });
  if (slugOrId) {
    return category;
  }
  return categories;
}

export function getCategorySlugById(id: number): string {
  let slug = '';
  getMainCategories().forEach((category) => {
    if (category.id === id && !slug) {
      slug = category.slug;
    }
  });
  return slug;
}

export function getCategoryById(id: number | null): string {
  if (!id) {
    return '';
  }
  let slug = getCategorySlugById(id);
  return getCategoryBySlug(slug);
}

export function getSubCategoryById(id: number) {
  const slugs = Object.keys(routesData);
  let category = false as any;
  slugs.map((slug) => {
    if (category) {
      return;
    }
    const parentCat = routesData[slug as keyof typeof routesData];
    if (parentCat.type !== 'category') {
      return;
    }
    if ('children' in parentCat && Object.keys(parentCat.children).length) {
      const slugs = Object.keys(parentCat.children);
      slugs.forEach((subCatSlug) => {
        if (category) {
          return;
        }
        const subCat = parentCat.children[
          subCatSlug as keyof typeof parentCat.children
        ] as any;
        if (subCat && 'id' in subCat && id == subCat.id) {
          category = subCat;
        }
      });
    }
  });
  return category;
}

export function getGroupById(id: number) {
  const slugs = Object.keys(routesData);
  let foundGroup = false as any;
  slugs.map((slug) => {
    if (foundGroup) {
      return;
    }
    const parentCat = routesData[slug as keyof typeof routesData];
    if (parentCat.type !== 'category') {
      return;
    }
    if ('children' in parentCat && Object.keys(parentCat.children).length) {
      const slugs = Object.keys(parentCat.children);
      slugs.forEach((subCatSlug) => {
        if (foundGroup) {
          return;
        }
        const subCat = parentCat.children[
          subCatSlug as keyof typeof parentCat.children
        ] as any;
        if ('children' in subCat && Object.keys(subCat.children).length) {
          const slugs = Object.keys(subCat.children);
          slugs.forEach((groupSlug) => {
            if (foundGroup) {
              return;
            }
            const group = subCat.children[
              groupSlug as keyof typeof subCat.children
            ] as any;
            if (group && 'groupid' in group && id == group.groupid) {
              foundGroup = group;
            }
          });
        }
      });
    }
  });
  return foundGroup;
}

export function getCategoryBySlug(slug: string, parentSlug?: string): any {
  let category = false as any;
  getMainCategories().forEach((cat) => {
    if (category) {
      return;
    }
    if (!parentSlug) {
      if (cat.slug === slug) {
        category = routesData[slug as keyof typeof routesData];
      }
    } else {
      if (cat.slug === parentSlug) {
        const parentCat = routesData[parentSlug as keyof typeof routesData];
        if (parentCat.type !== 'category') {
          return;
        }
        if ('children' in parentCat && Object.keys(parentCat.children).length) {
          const slugs = Object.keys(parentCat.children);
          slugs.forEach((subCatSlug) => {
            if (category) {
              return;
            }
            if (subCatSlug === slug) {
              category =
                parentCat.children[slug as keyof typeof parentCat.children];
            }
          });
        }
      }
    }
  });
  return category;
}

export function getParentCategory(categoriesData: any, categoryId: number) {
  let parentCategory = false as any;
  categoriesData.forEach((cat: any) => {
    if (parentCategory) {
      return;
    }
    if (cat.id === categoryId) {
      parentCategory = cat.parent_id;
    }
  });
  if (parentCategory < 1) {
    return false;
  }
  return parentCategory;
}
